import ReactPlayer, { ReactPlayerProps } from 'react-player';

interface AudioPlayerProps extends Omit<ReactPlayerProps, 'width' | 'height' | 'controls'> {}

const AudioPlayer = (props: AudioPlayerProps) => {
  return (
    <div>
      <ReactPlayer width="260px" height="40px" controls={true} {...props} />
    </div>
  );
};

export default AudioPlayer;
